import { staticMapElement, osmTile, OSM_CREDIT } from '../../../modules/map/static-preview.js';
// public/js/features/assets/components/last-position-hover.js
// Popovers are rendered into <body> (container:'body'), so they outlive the row
// that spawned them: replacing the table's rows or leaving the page used to
// strand a map preview floating over the app. Always dispose the previous ones
// before wiring new cells, and expose a teardown for the page to call.
export function disposeLastPositionHovers() {
  document.querySelectorAll('.popover-asset-map').forEach(el => { try { el.remove(); } catch (e) {} });
  document.querySelectorAll('.last-position-cell').forEach(cell => {
    try { bootstrap.Popover.getInstance(cell)?.dispose(); } catch (e) {}
  });
}

export function setupLastPositionHover(tbody) {
  disposeLastPositionHovers();
  const cells = tbody.querySelectorAll('.last-position-cell');

  cells.forEach(cell => {
    const lat = parseFloat(cell.dataset.lat);
    const lon = parseFloat(cell.dataset.lon);
    if (isNaN(lat) || isNaN(lon)) return;

    // Tiles, not a Google static image: no key, no per-request cost, and none
    // of the caching / non-Google-map clauses (docs/maps.md). A few <img> in a
    // clipped box is also lighter than one map instance per row would be.
    //
    // An ELEMENT, not a string: Bootstrap sanitises string popover content and
    // its allow-list has neither `style` nor `<svg>`, so a string arrived with
    // every position stripped and no pin - the tiles flowed and the box showed
    // its top-left corner rather than the asset.
    const popoverContent = document.createElement('div');
    popoverContent.className = 'asset-map-wrapper';
    popoverContent.appendChild(staticMapElement({
      lat, lon, zoom: 12, width: 265, height: 195,
      tileUrl: osmTile, attribution: OSM_CREDIT,
      alt: `Position ${lat.toFixed(5)}, ${lon.toFixed(5)}`,
    }));

    new bootstrap.Popover(cell, {
      html: true,
      trigger: 'hover',
      placement: 'auto',
      fallbackPlacements: ['right', 'left', 'top', 'bottom'],
      delay: { show: 80, hide: 150 },
      container: 'body',
      customClass: 'popover-asset-map',   // ← important for the CSS rules
      content: popoverContent
    });
  });
}